'use strict';

var langCode = require('cjs-iso-639');


/**
 * Transform language codes to readable format.
 *
 * @param {Array} codes - language codes to transform
 *
 * @return {string} languages
 */
function fillLanguage ( codes ) {
    var languages = [];

    codes.forEach(function ( code ) {
        var tempLang = langCode['1'][code] || langCode['2B'][code] ||
            langCode['2T'][code];

        if ( tempLang ) {
            languages.push(tempLang[1]);
        } else {
            languages.push(code || gettext('Unknown language'));
        }
    });

    return  languages.join(', ');
}


/**
 * Prepare data for files list.
 *
 * @param {Object} data - data to prepare
 *
 * @return {Array} prepared data
 */
module.exports = function ( data ) {
    var subList = [],
        result = [],
        name, lang;

    data.forEach(function ( item ) {
        lang = [];
        item.subList = subList;
        if ( item.languages.length ) {
            lang = fillLanguage(item.languages);
        } else {
            lang = gettext('Unknown language');
        }
        if ( item.quality ) {
            name = (item.quality.code ? item.quality.code + ' (' : '(')
                + (item.quality.name ? item.quality.name : gettext('Unknown quality')) + ')';
        } else {
            name = '(' + gettext('Unknown quality') + ')';
        }

        result.push({
            state: false,
            title: lang + ' ' + name,
            value: item
        });
    });

    return result;
};
